import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=7e79ad1b&"
import script from "./ItemTable.vue?vue&type=script&lang=ts&"
export * from "./ItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports